import Vue from "vue"
import messageBoxComponent from "./messageBox.vue"
const messageBoxCom = Vue.extend(messageBoxComponent)

let instance = null
const defaults = {
  title: "",
  message: ""
}

const messageBox = {
  open(options = {}) {
    return new Promise((resolve, reject) => {
      if (instance) {
        instance.visible = false
      }
      instance = new messageBoxCom({
        el: document.createElement("template"),
        propsData: {
          content: options
        }
      })
      instance.callback = action => {
        if (action === "confirm") {
          resolve("confirm")
        } else if (action === "cancel") {
          reject("cancel")
        }
      }
      if (options?.showMask == false) {
        instance.showMask = false
      }
      if (options?.showClose == false) {
        instance.showClose = false
      }
      if (options.disMaskClick) {
        instance.disMaskClick = options.disMaskClick
      }
      if (options?.showButton == false) {
        instance.showButton = options.showButton
      }
      instance.visible = true
      document.body.appendChild(instance.$el)
    })
  },
  close() {
    instance.visible = false
  }
}
export default {
  install() {
    if (!Vue.$messageBox) {
      Vue.$messageBox = messageBox
    }
    Vue.mixin({
      created() {
        this.$messageBox = Vue.$messageBox
      }
    })
    Vue.component("MessageBox", messageBoxComponent)
  }
}
